import { URLS } from '../../../consts/endpoints';
import store from '../../../store/store';
import { getData } from '../../../utils/http';
import { isArray, isUndefined } from '../../../utils/isDefined';
import { actions as reduxActions } from '../reducers';
import { actions as loaderReduxActions } from '../../../partials/loader/reducers';
import Optional from '../../../utils/optional';

const fetchSubscriptions = (client, selectedAccount, category = 'IoT') => {
  return async dispatch => {
    dispatch(loaderReduxActions.startSpinLoader());

    const queryParam = category === 'IoT' ? 'product_category=IoT' : 'sku=MBB';
    const matchesCategory = sku =>
      category !== 'MBB' || (typeof sku === 'string' && sku.startsWith('MBB'));

    if (selectedAccount?.value === 'all') {
      const accounts = store.getState().iotProducts?.accounts;
      let subsArray = [];

      const accountReferences = accounts
        .filter(acc => acc.value !== 'all')
        .map(acc => acc.externalReference);

      try {
        const accountSubsPromises = accountReferences.map(reference =>
          getData(
            `${URLS.QUOTE_CLIENTS_V2}/${client}/subscriptions?account_reference=${reference}&${queryParam}`
          )
        );

        const results = await Promise.all(accountSubsPromises);

        results.forEach(accountSubs => {
          if (isArray(accountSubs)) {
            const accountMappedSubs = accountSubs.reduce((arr, sub) => {
              if (
                isUndefined(sub?.subscription) ||
                !matchesCategory(sub?.subscription?.sku)
              ) {
                return arr;
              }
              const account = accounts.find(
                acc =>
                  acc.externalReference === sub?.subscription?.accountReference
              );
              const icc = findIcc(sub?.subscription);

              return [
                ...arr,
                {
                  ...sub?.subscription,
                  account: Optional(account?.label).or(''),
                  icc
                }
              ];
            }, []);

            subsArray = [...subsArray, ...accountMappedSubs];
          }
        });

        dispatch(reduxActions.setSubscriptions(subsArray));
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    } else {
      const accountSubs = await getData(
        `${URLS.QUOTE_CLIENTS_V2}/${client}/subscriptions?account_reference=${selectedAccount?.externalReference}&${queryParam}`
      );

      if (isArray(accountSubs)) {
        const accountMappedSubs = accountSubs.reduce((arr, sub) => {
          if (
            isUndefined(sub?.subscription) ||
            !matchesCategory(sub?.subscription?.sku)
          ) {
            return arr;
          }
          const icc = findIcc(sub?.subscription);

          return [
            ...arr,
            { ...sub?.subscription, account: selectedAccount?.label, icc }
          ];
        }, []);

        dispatch(reduxActions.setSubscriptions(accountMappedSubs));
      }
    }
    dispatch(loaderReduxActions.stopSpinLoader());
  };
};

export default fetchSubscriptions;

const findIcc = sub => {
  if (!sub?.features) {
    return void 0;
  }

  const phoneFeature = sub.features.find(
    feat => feat.key === 'phone-and-sim-card'
  );

  if (!phoneFeature?.featureAttributes) {
    return void 0;
  }

  const simcard = phoneFeature.featureAttributes.find(
    el => el.key === 'resources-sim-cards-primary'
  );

  return Optional(simcard?.value).or(void 0);
};
